export default __webpack_public_path__ + "static/media/img4.d6d15d94.jpg";